import { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/rentApi";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentReturn() {
  const location = useLocation();
  const navigate = useNavigate();
  const isCancel = location.pathname.includes("cancel");
  const [status, setStatus] = useState(isCancel ? "cancel" : "checking");

  useEffect(() => {
    if (isCancel) return;
    const sid = new URLSearchParams(location.search).get("session_id");
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("error"); return; }
      } catch { /* keep polling */ }
      if (tries++ < 8) setTimeout(poll, 2000);
      else setStatus("error");
    };
    poll();
  }, [isCancel, location.search]);

  const config = {
    checking: { icon: Loader2, spin: true, title: "Vérification du paiement…", desc: "Merci de patienter quelques secondes." },
    paid: { icon: CheckCircle2, color: "text-[hsl(var(--chart-2))]", title: "Paiement confirmé", desc: "Votre loyer a bien été réglé." },
    cancel: { icon: XCircle, color: "text-muted-foreground", title: "Paiement annulé", desc: "Aucun montant n'a été débité." },
    error: { icon: XCircle, color: "text-destructive", title: "Paiement non confirmé", desc: "Réessayez ou contactez votre propriétaire." },
  }[status];
  const Icon = config.icon;

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-sm w-full text-center border border-border rounded-2xl bg-card p-8">
        <Icon className={`w-14 h-14 mx-auto ${config.color || ""} ${config.spin ? "animate-spin" : ""}`} />
        <h1 className="font-heading text-2xl font-bold mt-4" data-testid="payment-status-title">{config.title}</h1>
        <p className="text-sm text-muted-foreground mt-2">{config.desc}</p>
        <Button className="rounded-full mt-6 w-full" onClick={() => navigate("/app/loyers")} data-testid="back-to-payments-btn">
          Retour aux loyers
        </Button>
        <Link to="/app" className="text-sm text-muted-foreground underline block mt-3">Tableau de bord</Link>
      </div>
    </div>
  );
}
